import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';
import getAppConfigs from 'modules/appConfig/reducer';
import api from 'modules/queries/api';
import { useOidcSilent } from './silentProvider';

const appConfigs = getAppConfigs();

export function ClubSauceBasicAuthConnector() {
	const { isLoading } = useAuth();
	const [isSilentLoading] = useOidcSilent();

	// handle auth changes
	useEffect(() => {
		// Pause sooner
		api.apiPause();

		if (isLoading || isSilentLoading) return undefined;

		api.apiSetBasicAuthorization(
			appConfigs?.guestAuth.username || '',
			appConfigs?.guestAuth.password || '',
		);

		// debounce to allow for oidc to catchup
		const timer = setTimeout(() => {
			api.apiUnpause();
		}, 1);

		return () => {
			clearTimeout(timer);
		};
	}, [isLoading, isSilentLoading]);

	return null;
}

export default ClubSauceBasicAuthConnector;
